import { Component, OnInit } from '@angular/core'
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms'
import { PatientDemographics } from '../../../../api/models'
import { GlobalSettingsService } from '../../../../api/services'
import { MessageService, ConfirmationService } from 'primeng/api'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  templateUrl: './patient-demographics.component.html',
})
export class PatientDemographicsComponent implements OnInit {
  patientdemoForm: UntypedFormGroup
  demographics: PatientDemographics
  constructor(
    private fb: UntypedFormBuilder,
    private globalsettingService: GlobalSettingsService,
    private messageService: MessageService,
      private route: ActivatedRoute,
      private router: Router,
  ) {}

  ngOnInit() {
    this.patientdemoForm = new UntypedFormGroup({
      fullName: new UntypedFormControl(false, Validators.nullValidator),
      gender: new UntypedFormControl(false, Validators.nullValidator),
      homePhone: new UntypedFormControl(false, Validators.nullValidator),
      address: new UntypedFormControl(false, Validators.nullValidator),
      dob: new UntypedFormControl(false, Validators.nullValidator),
      workPhone: new UntypedFormControl(false, Validators.nullValidator),
      mobilePhone: new UntypedFormControl(false, Validators.nullValidator),
      age: new UntypedFormControl(false, Validators.nullValidator),
        mrn: new UntypedFormControl(false, Validators.nullValidator),
        insuranceCompany: new UntypedFormControl(false, Validators.nullValidator),
        pharmacyName: new UntypedFormControl(false, Validators.nullValidator),
        pharmacyPhone: new UntypedFormControl(false, Validators.nullValidator),
    })
    this.loadPatientDemographics()
  }
  loadPatientDemographics() {
    this.globalsettingService.globalSettingsGet({}).subscribe((result) => {
      debugger
      this.demographics = result
      this.patientdemoForm.patchValue(this.demographics)
    })
  }

  save() {
    debugger
    this.globalsettingService
      .globalSettingsPatientdemographics({
        body: this.patientdemoForm.value,
      })
      .subscribe((result) => {
        debugger

        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          summary: 'Confirmation',
          detail: 'Demographics  Updated Successfully',
          life: 7000,
        })
      })
    }
    backToGlobalMappingSetting() {
        this.router.navigate(['administration', 'listmapping'])
    }
}
